module.exports = __webpack_public_path__ + "components/layout/images/weixin.png?2d60a6ac";


//////////////////
// WEBPACK FOOTER
// ./components/layout/images/weixin.png
// module id = 242
// module chunks = 0